// extracted by mini-css-extract-plugin
export default {"container":"PageHeader_container__+Rm2S"};